/** Release 3 REV-2 — follow / unfollow toggle for the board header (`Board.followed`). */
import { Bell, BellOff } from 'lucide-react';
import type { Board } from '@/lib/api/types';
import { useFollowBoard } from '@/lib/api/queries';
import { Button } from '@/components/Button';
import { toast } from '@/stores/ui';
import { isApiError } from '@/lib/api/errors';

export function FollowButton({ board }: { board: Board }) {
  const followed = Boolean((board as { followed?: boolean }).followed);
  const m = useFollowBoard(board.id);
  return (
    <Button
      size="sm"
      variant={followed ? 'secondary' : 'ghost'}
      aria-pressed={followed}
      title={followed ? 'Stop following: no more notifications for comments, approvals and uploads in this board' : 'Follow: get notified about comments, approvals and uploads in this board and its sub-boards'}
      onClick={() => m.mutate(!followed, { onError: (e) => toast({ kind: 'error', title: isApiError(e) ? e.message : 'Could not update follow state' }) })}
      disabled={m.isPending}
      data-follow-board
    >
      {followed ? <BellOff size={13} /> : <Bell size={13} />} {followed ? 'Following' : 'Follow'}
    </Button>
  );
}
